import { GD } from "src/GD";

export class AccountsService {
	constructor() {
		GD.REQ_ACCOUNTS.listener = this.getAccounts;
		GD.REQ_GET_ACCOUNT_TEMPLATE.listener = this.getAccountTemplate;
		GD.REQ_CREATE_ACCOUNT.listener = this.createAccount;
		GD.REQ_GET_ACCOUNT.listener = this.getAccount;
		GD.REQ_ACCOUNT_ADD_FUNDS.listener = this.addFunds;
		GD.REQ_ACCOUNT_BLOCK.listener = this.blockAccount;
	}

	private getAccounts: () => Promise<IAPIResponse<IAccountSaved[]>> = async () => {
		return (await GD.REQ_API.request({
			httpMethod: "GET",
			method: "accounts/list",
		})) as IAPIResponse<IAccountSaved[]>;
	};

	private refreshAccounts = async () => {
		const response = await this.getAccounts();
		if (response.data) GD.S_ACCOUNTS_LIST_UPDATED.invoke(response.data);
	};

	private getAccount: (uid: string) => Promise<IAPIResponse<IAccountSaved>> = async uid => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: `accounts/get?uid=${uid}`,
		});
		return res as IAPIResponse<IAccountSaved>;
	};

	private getAccountTemplate: () => Promise<IAPIResponse<IAccountRaw>> = async () => {
		const res = await GD.REQ_API.request({
			httpMethod: "GET",
			method: "accounts/get?uid=-1",
		});
		return res as IAPIResponse<IAccountRaw>;
	};

	private createAccount: (data: IAccountRaw) => Promise<IAPIResponse<IAccountRaw>> = async data => {
		const res = await GD.REQ_API.request({
			method: "accounts/create",
			httpMethod: "POST",
			data,
		});
		if (!res.error) await this.refreshAccounts();
		return res as IAPIResponse<IAccountRaw>;
	};

	private addFunds: (data: { uid: string; amount: number }) => Promise<IAPIResponse<boolean>> = async data => {
		const res = await GD.REQ_API.request({
			method: "accounts/add/funds",
			httpMethod: "POST",
			data,
		});
		if (!res.error) await this.refreshAccounts();
		return res as IAPIResponse<boolean>;
	};

	private blockAccount: (data: { uid: string }) => Promise<IAPIResponse<boolean>> = async data => {
		const res = await GD.REQ_API.request({
			method: "accounts/block",
			httpMethod: "POST",
			data,
		});
		if (!res.error) await this.refreshAccounts();
		return res as IAPIResponse<boolean>;
	};
}
